<div id="fp_one" class="liquid-form-area" [ngClass]="sucessClassAdd">
    <div class="liquid-form-logo">
        <a href="#"><img src="assets/images/logo.png" alt="" /></a>
    </div>
    <div class="liquid-form-heading-text">
        <h4>Forgot Password?</h4>
        <p>
            Enter your email address and we’ll send you a link to reset your
            password.
        </p>
    </div>
    <div class="liquid-form-content">
        <form [formGroup]="forgotForm" (ngSubmit)="forgot()">
            <!-- single liquid form  -->
            <div class="single-liquid-form">
                <label for="forgot_mail">Email</label>
                <input
                    id="forgot_mail"
                    type="email"
                    placeholder="Email"
                    formControlName="email"
                />
                <div
                    *ngIf="
                        forgotForm.controls['email'].touched &&
                        !forgotForm.controls['email'].valid
                    "
                >
                    <span
                        *ngIf="
                            forgotForm.controls['email'].hasError('required')
                        "
                    >
                        Email address is required
                    </span>
                    <span
                        *ngIf="forgotForm.controls['email'].hasError('email')"
                    >
                        Email address is not valid
                    </span>
                </div>
            </div>
            <!-- single liquid form  -->
            <div class="liquid-login-form-submit">
                <div id="fast-btn">
                    <button
                        type="submit"
                        [disabled]="forgotForm.invalid || isLoader"
                    >
                        <i
                            class="fa fa-circle-o-notch fa-spin"
                            *ngIf="isLoader"
                        ></i>
                        SEND PASSWORD RESET LINK
                    </button>
                </div>
            </div>
        </form>
        <div class="error-message text-center">
            <!---- Error Response ---->
            <p>{{ loginError }}</p>
        </div>
        <div class="back-to-login-link">
            <a routerLink="/auth/login">Back to Login</a>
        </div>
    </div>
</div>
<div id="fp_two" class="liquid-form-area tabcontent" [ngClass]="sucessClass">
    <div class="liquid-form-logo">
        <a href="#"><img src="assets/images/logo.png" alt="" /></a>
    </div>
    <div class="liquid-form-heading-text">
        <h4>Reset Password Link Sent!</h4>
        <p>
            We sent you an email which contains a link to reset your password.
        </p>
    </div>
    <div class="back-to-login-link">
        <a routerLink="/auth/login">Back to Login</a>
    </div>
</div>
